import {
    ViewerApp,
    AssetManagerPlugin,
    addBasePlugins,
} from "webgi";
import "./styles.css";

async function setupViewer(){

    const viewer = new ViewerApp({
        canvas: document.getElementById('webgi-canvas')
    })

    const camera = viewer.scene.activeCamera
    const manager = await viewer.addPlugin(AssetManagerPlugin)

    await addBasePlugins(viewer)
    // viewer.renderer.displayCanvasScaling = Math.min(window.devicePixelRatio, 2)
    viewer.renderer.refreshPipeline()

    await manager.addFromPath("./assets/toyota_supra.glb")


    if(camera.controls){
        // camera.controls.autoRotate = true
        camera.controls.minDistance = 3
        camera.controls.maxDistance = 6
        camera.controls.enableDamping = true
    }

}

setupViewer()
